export const colors = {
    white: "var(--color-background-0)",
    dark: {
        muted: "#334155",
        background: "#0F172A"
    },
    primary: {
        // `/<alpha-value>` doesn't work inside a spinner component
        // which sets it as stroke color
        0: "var(--color-primary-0)",
        50: "var(--color-primary-50)",
        100: "var(--color-primary-100)",
        200: "var(--color-primary-200)",
        300: "var(--color-primary-300)",
        400: "var(--color-primary-400)",
        500: "var(--color-primary-500)",
        600: "var(--color-primary-600)",
        700: "var(--color-primary-700)",
        800: "var(--color-primary-800)",
        900: "var(--color-primary-900)",
        950: "var(--color-primary-950)"
    },
    secondary: {
        0: "var(--color-secondary-0)",
        50: "var(--color-secondary-50)",
        100: "var(--color-secondary-100)",
        200: "var(--color-secondary-200)",
        300: "var(--color-secondary-300)",
        400: "var(--color-secondary-400)",
        500: "var(--color-secondary-500)",
        600: "var(--color-secondary-600)",
        700: "var(--color-secondary-700)",
        800: "var(--color-secondary-800)",
        900: "var(--color-secondary-900)",
        950: "var(--color-secondary-950)"
    },
    tertiary: {
        50: "var(--color-tertiary-50)",
        100: "var(--color-tertiary-100)",
        200: "var(--color-tertiary-200)",
        300: "var(--color-tertiary-300)",
        400: "var(--color-tertiary-400)",
        500: "var(--color-tertiary-500)",
        600: "var(--color-tertiary-600)",
        700: "var(--color-tertiary-700)",
        800: "var(--color-tertiary-800)",
        900: "var(--color-tertiary-900)",
        950: "var(--color-tertiary-950)"
    },
    error: {
        0: "var(--color-error-0)",
        50: "var(--color-error-50)",
        100: "var(--color-error-100)",
        200: "var(--color-error-200)",
        300: "var(--color-error-300)",
        400: "var(--color-error-400)",
        500: "var(--color-error-500)",
        600: "var(--color-error-600)",
        700: "var(--color-error-700)",
        800: "var(--color-error-800)",
        900: "var(--color-error-900)",
        950: "var(--color-error-950)"
    },
    success: {
        0: "var(--color-success-0)",
        50: "var(--color-success-50)",
        100: "var(--color-success-100)",
        200: "var(--color-success-200)",
        300: "var(--color-success-300)",
        400: "var(--color-success-400)",
        500: "var(--color-success-500)",
        600: "var(--color-success-600)",
        700: "var(--color-success-700)",
        800: "var(--color-success-800)",
        900: "var(--color-success-900)",
        950: "var(--color-success-950)"
    },
    info: {
        0: "var(--color-info-0)",
        50: "var(--color-info-50)",
        100: "var(--color-info-100)",
        200: "var(--color-info-200)",
        300: "var(--color-info-300)",
        400: "var(--color-info-400)",
        500: "var(--color-info-500)",
        600: "var(--color-info-600)",
        700: "var(--color-info-700)",
        800: "var(--color-info-800)",
        900: "var(--color-info-900)",
        950: "var(--color-info-950)"
    },
    typography: {
        0: "var(--color-typography-0)",
        50: "var(--color-typography-50)",
        100: "var(--color-typography-100)",
        200: "var(--color-typography-200)",
        300: "var(--color-typography-300)",
        400: "var(--color-typography-400)",
        500: "var(--color-typography-500)",
        600: "var(--color-typography-600)",
        700: "var(--color-typography-700)",
        800: "var(--color-typography-800)",
        900: "var(--color-typography-900)",
        950: "var(--color-typography-950)",
        white: "#FFFFFF",
        gray: "#D4D4D4",
        black: "#181718"
    },
    outline: {
        0: "var(--color-outline-0)",
        50: "var(--color-outline-50)",
        100: "var(--color-outline-100)",
        200: "var(--color-outline-200)",
        300: "var(--color-outline-300)",
        400: "var(--color-outline-400)",
        500: "var(--color-outline-500)",
        600: "var(--color-outline-600)",
        700: "var(--color-outline-700)",
        800: "var(--color-outline-800)",
        900: "var(--color-outline-900)",
        950: "var(--color-outline-950)"
    },
    background: {
        0: "var(--color-background-0)",
        50: "var(--color-background-50)",
        100: "var(--color-background-100)",
        200: "var(--color-background-200)",
        300: "var(--color-background-300)",
        400: "var(--color-background-400)",
        500: "var(--color-background-500)",
        600: "var(--color-background-600)",
        700: "var(--color-background-700)",
        800: "var(--color-background-800)",
        900: "var(--color-background-900)",
        950: "var(--color-background-950)",
        error: "var(--color-background-error)",
        warning: "var(--color-background-warning)",
        muted: "var(--color-background-muted)",
        success: "var(--color-background-success)",
        info: "var(--color-background-info)",
        light: "#FBFBFB",
        dark: "#181719"
    },
    indicator: {
        primary: "var(--color-indicator-primary)",
        info: "var(--color-indicator-info)",
        error: "var(--color-indicator-error)"
    },
    // extras
    danger: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337"
    },
    rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337"
    },
    pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843"
    },
    fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75"
    },
    purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87"
    },
    violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95"
    },
    indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81"
    },
    blue: {
        50: "var(--color-blue-50)",
        100: "var(--color-blue-100)",
        200: "var(--color-blue-200)",
        300: "var(--color-blue-300)",
        400: "var(--color-blue-400)",
        500: "var(--color-blue-500)",
        600: "var(--color-blue-600)",
        700: "var(--color-blue-700)",
        800: "var(--color-blue-800)",
        900: "var(--color-blue-900)"
    },
    lightBlue: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e"
    },
    darkBlue: {
        50: "#dbf4ff",
        100: "#addbff",
        200: "#7cc2ff",
        300: "#4aa9ff",
        400: "#1a91ff",
        500: "#0077e6",
        600: "#005db4",
        700: "#004282",
        800: "#002851",
        900: "#000e21"
    },
    cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63"
    },
    teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a"
    },
    emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b"
    },
    green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d"
    },
    lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314"
    },
    yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12"
    },
    amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f"
    },
    orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12"
    },
    red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d"
    },
    warmGray: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917"
    },
    trueGray: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717"
    },
    gray: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b"
    },
    coolGray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827"
    },
    // read from config like primary above
    blueGray: {
        50: "var(--color-blueGray-50)",
        100: "var(--color-blueGray-100)",
        200: "var(--color-blueGray-200)",
        300: "var(--color-blueGray-300)",
        400: "var(--color-blueGray-400)",
        500: "var(--color-blueGray-500)",
        600: "var(--color-blueGray-600)",
        700: "var(--color-blueGray-700)",
        800: "var(--color-blueGray-800)",
        900: "var(--color-blueGray-900)",
        950: "var(--color-blueGray-950)"
    },
    warning: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12"
    },
    Airbnb: {
        primary: "#FF5A5F",
        background: "var(--color-Airbnb-background)", // background event
        border: "var(--color-Airbnb-border)", // border event
        text: "var(--color-Airbnb-text)", // text color event
        avatar: "var(--color-Airbnb-avatar)" // avatar color event
    },
    Booking: {
        primary: "#003B95",
        background: "var(--color-Booking-background)", // background event
        border: "var(--color-Booking-border)", // border event,
        text: "var(--color-Booking-text)", // text color event
        avatar: "var(--color-Booking-avatar)"
    },
    Houfy: {
        primary: "#153D59",
        background: "var(--color-Houfy-background)", // background event
        border: "var(--color-Houfy-border)", // border event,
        text: "var(--color-Houfy-text)", // text color event
        avatar: "var(--color-Houfy-avatar)"
    },
    HomeAway: {
        primary: "#245ABC",
        background: "var(--color-HomeAway-background)", // background event
        border: "var(--color-HomeAway-border)", // border event,
        text: "var(--color-HomeAway-text)", // text color event
        avatar: "var(--color-HomeAway-avatar)"
    },
    internal: {
        primary: "#36BDB6",
        background: "var(--color-internal-background)", // background event
        border: "var(--color-internal-border)", // border event,
        text: "var(--color-internal-text)", // text color event
        avatar: "var(--color-internal-avatar)"
    },
    direct: {
        primary: "#36BDB6",
        background: "var(--color-direct-background)", // background event
        border: "var(--color-direct-border)", // border event,
        text: "var(--color-direct-text)", // text color event
        avatar: "var(--color-direct-avatar)"
    },
    icalendar: {
        primary: "#EA580C",
        background: "var(--color-icalendar-background)", // background event
        border: "var(--color-icalendar-border)", // border event,
        text: "var(--color-icalendar-text)", // text color event
        avatar: "var(--color-icalendar-avatar)"
    },
    alert: {
        info: {
            text: "#2563EB"
        },
        success: {
            text: "#16A34A"
        },
        warning: {
            text: "#F59E0B"
        },
        error: {
            text: "#DC2626"
        }
    }
};
